import { constants } from '../constants/global.constants'
import moment from 'moment'

export function filterReducer(
  state = { startDate: 0, endDate: moment().add(2, 'y').valueOf(), minimumProgress: 0, maxProgress: 100 },
  action
) {
  switch (action.type) {
    case constants.CHANGE_FILTER:
      return Object.assign({}, state, {
          startDate: action.taskFilter.startDate,
          endDate: action.taskFilter.endDate,
        minimumProgress: action.taskFilter.minimumProgress,
          maxProgress: action.taskFilter.maxProgress,
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/filter.reducer.js